import { render, staticRenderFns } from "./_CommercialLaw.vue?vue&type=template&id=1524b0d3&scoped=true&"
import script from "./_CommercialLaw.vue?vue&type=script&lang=js&"
export * from "./_CommercialLaw.vue?vue&type=script&lang=js&"
import style0 from "./_CommercialLaw.vue?vue&type=style&index=0&id=1524b0d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1524b0d3",
  null
  
)

export default component.exports